<template>
  <div>
    <div
      class="full-label"
      v-html="text"
    />
  </div>
</template>

<script>
export default {
  name: 'FullLabel',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.full-label {
  width: 100%;
  background: rgb(255, 247, 204);
  margin-bottom: 20px;
  text-align: center;
  font-size: 15px;
  color: rgb(255, 102, 0);
  padding: 10px;
  border-radius: 3px;
  -webkit-box-shadow: 0 2px 4px 0 rgba(85, 85, 85, 0.5);
  box-shadow: 0 2px 4px 0 rgba(85, 85, 85, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/FullLabel.vue